import React, { useState, useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const useReservationForm = (spaceDetail) => {
  const [isLoading, setIsLoading] = useState(false);
  const lenguage = useSelector((state) => state.lenguage?.lang);
  const navigate = useNavigate();

  const goToCheckout = (values, spaceDetail) => {
    ReactPixel.trackCustom('goToCheckout', {
      reservationData: {
        reservationDetails: values,
        spaceDetails: spaceDetail,
      },
    });

    navigate(lenguage === 'ES' ? '/pago' : '/pay', {
      state: { spaceDetail, values },
    });
  };

  useEffect(() => {
    if (spaceDetail.length >= 1) {
      setIsLoading(false);
    }
  }, [spaceDetail]);

  return {
    isLoading,
    setIsLoading,
    goToCheckout,
  };
};
